module.exports = __webpack_public_path__ + "static/media/tip_w.78d41604.svg";